import React from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../../../common/hooks/hooks";
import type { TransformedProduct } from "../../types/productApiTypes";
import { findMatchingReferenceCodes } from "../../helpers/referenceCodeHelpers";

const ReferenceCodes: React.FC<{ product: TransformedProduct; matchedOnly?: boolean }> = ({ product, matchedOnly = false }) => {
  const { t } = useTranslation();
  const term = useAppSelector((state) => state.product.filters.search);
  const codes = product.referenceCodes || [];
  const displayed = matchedOnly
    ? findMatchingReferenceCodes([
        ...(product.sku ? [{ type: "product" as const, brand: "", code: product.sku }] : []),
        ...codes,
      ], term)
    : codes;
  if (!displayed.length) return null;

  return (
    <ul className="product-reference-codes" aria-label={t(matchedOnly ? "referenceCodes.matches" : "referenceCodes.title")}>
      {displayed.map((row) => {
        const label = row.type === "brand"
          ? t("referenceCodes.brand", { brand: row.brand })
          : t(row.type === "oem" ? "referenceCodes.oem" : "referenceCodes.product");
        return (
          <li key={`${row.type}:${row.brand}:${row.code}`}>
            <strong>{matchedOnly ? t("referenceCodes.matched", { label }) : label}:</strong>{" "}
            <span>{row.code}</span>
          </li>
        );
      })}
    </ul>
  );
};

export default ReferenceCodes;
